import fetch from "@/uilts/request";

export default {
    async open(data) {
        return await fetch.post("GaoXiang/open", data)
    },
    async submit(data) {
        return await fetch.post("GaoXiang/submit", data)
    },
    async status(data) {
        return await fetch.post("GaoXiang/status", data)
    },
    async revoke(data) {
        return await fetch.post("GaoXiang/revoke", data)
    },
    async getSignLink(data) {
        return await fetch.post("GaoXiang/getSignLink", data)
    },
}
